import styled from 'styled-components';

export const ResourceLinkWrap = styled.div`
  display: grid;
  grid-template-columns: auto max-content;
  align-items: center;
  --base-height: 42px;
  height: var(--base-height);
  /* 8px - 8px (padding on icon)  = 0px on right;  max h = 32px (menu button), => 5+5 for 42px height */
  padding: var(--i-padding-block, 5px) 0px var(--i-padding-block, 5px) 8px;
  column-gap: 8px;

  :not(:first-of-type) {
    padding-top: 0px;
    margin-top: 4px;
    /* Handle including line in grid */
    height: calc(var(--base-height) + 4px);

    &::before {
      content: '';
      display: block;
      width: 100%;
      /* 5px padding  + 4px - border-width(1px) */
      margin-bottom: calc(var(--i-padding-block, 5px) + 3px);
      border-bottom: 1px solid #e6e8f0;
      grid-column: 1 / -1;
    }
  }
`;
export const Row = styled.div`
  align-self: stretch;
  display: grid;
  grid-template-columns: max-content auto;
  column-gap: 8px;

  align-items: center;
  overflow: hidden;

  & :nth-child(3) {
    grid-column: 2;
  }
`;
export const Button = styled.button`
  /* Base */
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 10px 16px;

  border-style: solid;
`;

export const ActionButton = styled(Button)`
  border: none;
  background-color: transparent;
  padding: 0;

  /* May be not just span on button. Blueprint span renders longer than star svg */
  & > * {
    display: flex;
  }
`;

// Base
export const ILink = styled.a`
  font-size: 14px;
  font-weight: 500;
  color: #1371fe;
  cursor: pointer;
`;
export const ResourceLabel = styled(ILink)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
